import { FC } from 'react'

import GoBackHeader from 'components/organisms/GoBackHeader'
import ContentNotAvailable from 'components/atoms/ContentNotAvailable'

import { BillingContainer } from './styles'

const Billing: FC = () => (
  <>
    <GoBackHeader text='Billing' />
    <BillingContainer>
      <h2>Feature Coming Soon</h2>
      <ContentNotAvailable
        iconClass='mdi-clock-outline'
        datatestid='billing-no-content'
      >
        We will let you know when this feature is available.
      </ContentNotAvailable>
    </BillingContainer>
  </>
)

export default Billing
